import { LOCAL_STORAGE_TAGS, TIME_FORMATS } from "constants/index"
import { vendors as VENDORS } from "config"
import moment from "moment"
import React, { useEffect, useRef } from "react"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import { google } from "config"
import { useLocation } from "react-router-dom/cjs/react-router-dom"

export const getFormDataFromJSON = bodyJSON => {
  let formData = new FormData()

  Object.keys(bodyJSON)?.map(key => {
    if (bodyJSON[key] !== null && bodyJSON[key] !== undefined) {
      if (Array?.isArray(bodyJSON[key])) {
        //formatting an array for formData and php requirements
        for (let i = 0; i < bodyJSON[key].length; i++) {
          if (bodyJSON[key][i] instanceof Blob) {
            if (bodyJSON[key][i]?.type?.includes("image")) {
              formData.append(`${key}[]`, bodyJSON[key][i], "image.png")
            } else {
              formData.append(`${key}[]`, bodyJSON[key][i])
            }
          } else {
            formData.append(`${key}[]`, bodyJSON[key][i])
          }
        }
      } else {
        if (bodyJSON[key] instanceof Blob) {
          if (bodyJSON[key]?.type?.includes("image")) {
            formData.append(key, bodyJSON[key], "image.png")
          } else {
            formData.append(key, bodyJSON[key])
          }
        } else {
          formData.append(key, bodyJSON[key])
        }
      }
    }
  })
  return formData
}

export const getSelectGroupOptions = (list, labelKey = "name") => {
  let optionGroup = []

  if (list && list?.length > 0) {
    let optionList = []
    for (let i = 0; i < list?.length; i++) {
      optionList?.push({ label: list[i][labelKey], value: list[i].id })
    }
    optionGroup = [
      {
        options: optionList,
      },
    ]
  }

  return optionGroup
}

export const checkPermission = permission => {
  let lsUserPermissions = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_TAGS.USER_PERMISSIONS_TAG)
  )
  let userPermissionsList = []
  if (lsUserPermissions && lsUserPermissions.length > 0) {
    userPermissionsList = lsUserPermissions[0].permissions
  }
  if (!userPermissionsList) {
    return false
  }
  return !!userPermissionsList?.find(p => p === permission)
}

export const checkClientConfig = (property, value = 1) => {
  let clientConfig =
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.CONFIG_TAG)) || {} //instead of validating with localstorage we should validate against our reducer

  return clientConfig[property] === value
}
export const checkFeatureAvailability = feature => {
  let lsFeaturesTag = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_TAGS.FEATURES_TAG)
  )
  return !!lsFeaturesTag?.find(p => p === feature)
}

export const userIsGodMode = () => {
  const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER))
  return user?.godMode
}

export const userIsCorporate = () => {
  const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER))
  return user.type === 2
}

export const isMpClient = () => {
  const vi = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG))
  return vi === VENDORS.MP_ID
}

export const isCagerClient = vendorId => {
  const vi = !!vendorId
    ? parseInt(vendorId)
    : JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG))
  return vi === VENDORS.CAGER_CLIENT_ID
}

export const isHarvardClient = vendorId => {
  const vi = !!vendorId
    ? parseInt(vendorId)
    : JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG))
  return vi === VENDORS.HARVARD_CLIENT_ID
}

export const isIfoClient = vendorId => {
  const vi = !!vendorId
    ? parseInt(vendorId)
    : JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG))
  return vi === VENDORS.IFO_CLIENT_ID
}

export const isWesternEdgeClient = vendorId => {
  const vi = !!vendorId
    ? parseInt(vendorId)
    : JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG))
  return vi === VENDORS.WESTERN_EDGE_CLIENT_ID
}

export const isEncapptureClient = () => {
  const vi = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG))
  return vi === VENDORS.ENCAPPTURE_CLIENT_ID
}

//region SIDEBAR ROUTES
export const getFormattedRoutesList = routes => {
  let allRoutes = [...routes]
  let routesList = []
  for (let i = 0; i < allRoutes.length; i++) {
    if (allRoutes[i].showOnMenu) {
      //if showOnMenu = false, the route can be ignored for the menu items list
      if (!allRoutes[i].menuGroup) {
        //pushes a simple route to the menu routes list
        routesList.push({ ...allRoutes[i], isMenuGroup: false })
      } else {
        // if the route is part of a menu group, will be added to a menu group dedicated object
        let menuGroupItem = null
        let menuGroupItemKey = null

        for (let j = 0; j < routesList.length; j++) {
          //checks if the menu group object is already created
          if (allRoutes[i].menuGroup in routesList[j]) {
            menuGroupItem = routesList[j]
            menuGroupItemKey = allRoutes[i].menuGroup
          }
        }

        if (menuGroupItem) {
          //if the menu group object already exist, pushes the route to its list of items
          menuGroupItem[menuGroupItemKey].push(allRoutes[i])
        } else {
          //if the menu group object does not exist yet, creates a new object and adds the route to it
          routesList.push({
            isMenuGroup: true,
            [allRoutes[i].menuGroup]: [{ ...allRoutes[i] }],
          })
        }
      }
    }
  }
  return routesList
}

export const getMenuGroupData = route => {
  let menuGroupData = {}

  let menuKey = null
  let routesList = []
  Object.keys(route).map(key => {
    if (key !== "isMenuGroup") {
      menuKey = key
      routesList = route[key]
    }
  })
  menuGroupData = {
    key: menuKey,
    routes: routesList,
  }
  return menuGroupData
}

//endregion SIDEBAR ROUTES

function addOrRemoveItemToList(item, checked, existingList) {
  let newList = [...existingList]
  let itemAlreadyAdded = false
  let itemPosition = 0
  for (let j = 0; j < newList.length; j++) {
    if (item.id === newList[j]) {
      itemAlreadyAdded = true
      itemPosition = j
    }
  }
  if (checked) {
    if (itemAlreadyAdded) {
      // newList = newList
    } else {
      newList.push(item.id)
    }
  } else {
    if (itemAlreadyAdded) {
      newList.splice(itemPosition, 1)
    } else {
      // return newList
    }
  }
  return newList
}

export const getUpdatedCheckedItemsList = (
  items,
  checked,
  checkedItemsList
) => {
  let updatedList = [...checkedItemsList]
  if (items instanceof Array) {
    if (items.length < 1) {
      updatedList = []
    } else {
      for (let i = 0; i < items.length; i++) {
        updatedList = addOrRemoveItemToList(items[i], checked, checkedItemsList)
      }
      return updatedList
    }
  } else {
    updatedList = addOrRemoveItemToList(items, checked, checkedItemsList)
  }
  return updatedList
}

const convertDateTimezone = (date, timezone) => {
  const moment = require("moment-timezone")
  let initialDate = moment.tz(date, timezone)
  let convertedDate = initialDate
    .clone()
    .tz(moment.tz.guess())
    .format("YYYY-MM-DD HH:mm:ss.SSSS")
  return convertedDate
}

export const getFormattedTime = (dateTime, timezone) => {
  let formattedTime
  if (!dateTime) {
    formattedTime = ""
  } else {
    const date = !!timezone
      ? moment(convertDateTimezone(dateTime, timezone))
      : moment(dateTime)
    if (moment().diff(date, "days", true) >= 6) {
      formattedTime = date.format(
        TIME_FORMATS(moment().diff(date, "days")).DATETIME
      )
    } else if (
      moment().diff(date, "days", true) < 6 &&
      moment().diff(date, "days", true) >= 2
    ) {
      formattedTime = date.format(
        TIME_FORMATS(moment().diff(date, "days")).DAYS_AGO
      )
    } else if (moment().diff(date, "days") === 1) {
      formattedTime = date.format(
        TIME_FORMATS(moment().diff(date, "days")).DAY_AGO
      )
    } else if (
      moment().diff(date, "days", true) < 1 &&
      moment().diff(date, "hours", true) >= 2
    ) {
      formattedTime = date.format(
        TIME_FORMATS(moment().diff(date, "hours")).HOURS_AGO
      )
    } else if (moment().diff(date, "hours") === 1) {
      formattedTime = date.format(
        TIME_FORMATS(moment().diff(date, "hours")).HOUR_AGO
      )
    } else {
      formattedTime = date.format(
        TIME_FORMATS(moment().diff(date, "minutes")).MIN_AGO
      )
    }
  }
  return formattedTime
}

export const getEventsPerCategory = (events = [], categories = []) => {
  let formattedList = []
  for (let i = 0; i < categories.length; i++) {
    formattedList.push(categories[i])
    categories[i].eventsList = []

    for (let j = 0; j < events.length; j++) {
      if (events[j].categories && events[j].categories.length > 0) {
        let belongsToCategory = false

        for (let k = 0; k < events[j].categories.length; k++) {
          if (events[j].categories[k].category_id === categories[i].id) {
            belongsToCategory = true
          }
        }
        if (belongsToCategory) {
          categories[i].eventsList.push(events[j])
        }
      }
    }
  }
  return formattedList
}

export const getFileBytes = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = event => {
      resolve(event.target.result)
    }

    reader.onerror = err => {
      reject(err)
    }

    if (file) {
      reader.readAsDataURL(file)
    } else {
      reject(new Error("file doesn't exists"))
    }
  })
}

export const showToast = (toastType, message, title) => {
  toastr.options = {
    positionClass: "toast-top-right",
    "closeButton": true,
    "progressBar": true,
  }

  //Toaster Types
  if (toastType === "info") toastr.info(message, title)
  else if (toastType === "warning") toastr.warning(message, title)
  else if (toastType === "error") toastr.error(message, title)
  else toastr.success(message, title)
}

export const usePrevious = value => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

const formatHex = hex => {
  return hex ? (hex.length === 1 ? `0${hex}` : hex.substring(0, 2)) : "00"
}

export const convertRgbaToHex = rgbaString => {
  if (!rgbaString) {
    return "#FFFFFF"
  } else {
    const values = rgbaString
      .toLowerCase()
      .replaceAll("r", "")
      .replaceAll("g", "")
      .replaceAll("b", "")
      .replaceAll("a", "")
      .replaceAll("(", "")
      .replaceAll(")", "")
      .replaceAll(" ", "")
      .split(",")
      .map(value => parseInt(value))

    return `#${formatHex(values[0].toString(16))}${formatHex(
      values[1].toString(16)
    )}${formatHex(values[2].toString(16))}`.toUpperCase()
  }
}

const dataURItoBlob = dataURI => {
  var byteString = atob(dataURI.split(",")[1])

  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0]

  var ab = new ArrayBuffer(byteString.length)
  var ia = new Uint8Array(ab)
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  return {
    blob: new Blob([ab], { type: mimeString }),
    mimeString,
  }
}

export const getFileBlob = (imageURI, fileName) => {
  if (!imageURI || imageURI.startsWith("http")) return null

  const { blob, mimeString } = dataURItoBlob(imageURI)

  if (!fileName) {
    return blob
  }

  return new File([blob], fileName, {
    type: mimeString,
  })
}

export const getLatAndLon = async place => {
  const address =
    place?.address_street_1 + "," + place?.city + "," + place?.state
  const time = Math.floor(Date.now() / 1000)
  const response = await fetch(
    "https://maps.googleapis.com/maps/api/geocode/json?address=" +
      address +
      "&timestamp=" +
      time +
      "&key=" +
      google.API_KEY
  )
  if (!response.ok) {
    throw new Error("Data coud not be fetched!")
  }
  const json = await response.json()
  return json
}

export const getTimezones = () => {
  const moment = require("moment-timezone")
  const timeZones = moment.tz.names()
  let timeZoneSelect = []
  for (var i in timeZones) {
    var x = {
      value: timeZones[i],
      label: "GMT" + moment.tz(timeZones[i]).format("Z") + " " + timeZones[i],
    }
    timeZoneSelect.push(x)
  }
  return timeZoneSelect
}

export const getCurrentDate = () => {
  const newDate = new Date()
  const today = `${newDate.getFullYear()}-${
    newDate.getMonth() < 9
      ? "0" + (newDate.getMonth() + 1)
      : newDate.getMonth() + 1
  }-${newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate()}`

  return today
}

export const copyButtonHandler = async text => {
  try {
    await navigator.clipboard.writeText(text)
    showToast("success", "Copied to clipboard!", "Success")
  } catch (error) {
    showToast("error", "Failed to copy!", "Error")
  }
}

export const getDownloadNameKey = download => {
  const vendor_id = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG)
  )
  return "download_ready_" + vendor_id + "_" + download?.id
}

export const useQuery = () => {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

export const returnMediaType = mediaType => {
  let response = false;
  let validImageTypes = ["image/jpg", "image/jpeg", "image/png", "image/gif", 'jpg', 'jpeg', 'png', 'gif'];
  let validVideoTypes = ["mp4", "video/mp4"];

  if (validImageTypes.indexOf(mediaType.toLowerCase()) !== -1) {
      response = 'img';
  } else if (validVideoTypes.indexOf(mediaType.toLowerCase()) !== -1) {
      response = 'video';
  }

  return response;
}

export const getApiErrorMessage = (response, includeKey = true) => {
  if (!response || !response?.data || !response?.data?.error) {
    return "An unknown error occurred. Please try again."
  }
  const errors = response?.data?.error
  let message = "Please try again"
  if (typeof errors === "string") {
    message = errors
  } else if (typeof errors === "object") {
    message = Object.entries(errors)
      ?.map(([key, value]) => {
        const errorMessage = Array.isArray(value) ? value.join(", ") : value
        return includeKey ? `${key}: ${errorMessage}` : `${errorMessage}`
      })
      ?.join("; ")
  }
  return message
}